'use strict';

var cookieHelpers = require('../common/cookie');

var GEO_DISMISSED_COOKIE = 'country_selector_dismissed';
var GEO_DISMISSED_COOKIE_DAYS = 30;

$(() => {
    const countrySelectorModal = '#countrySelectorModal';
    const $countrySelectorModal = $(countrySelectorModal);
    const $modalSelect = $countrySelectorModal.find('#modalCountrySelector');
    const $redirectButton = $countrySelectorModal.find('.js-countrySelectorRedirect');
    let isSelectpickerConfigured = false;

    const configureSelectpicker = () => {
        if (isSelectpickerConfigured || !$modalSelect.length || typeof $modalSelect.selectpicker !== 'function') {
            return;
        }

        // Render the dropdown outside modal body to avoid clipping from modal overflow.
        $modalSelect.selectpicker({
            container: 'body'
        });
        isSelectpickerConfigured = true;
    };

    const getSelectedLocaleData = () => {
        const $selectedOption = $modalSelect.find('option:selected');

        return {
            country: String($selectedOption.val() || ''),
            url: String($selectedOption.data('url') || ''),
            locale: String($selectedOption.data('locale') || ''),
            currencyCode: String($selectedOption.data('currencycode') || '')
        };
    };

    const syncModalState = () => {
        const selectedLocaleData = getSelectedLocaleData();
        $redirectButton.attr('data-url', selectedLocaleData.url);
        $redirectButton.attr('data-locale', selectedLocaleData.locale);
        $redirectButton.attr('data-currencycode', selectedLocaleData.currencyCode);
    };

    const preselectGeoOption = (data) => {
        let $matchingOption = $();

        if (!$modalSelect.length || !data) {
            return;
        }

        if (data.mappedLocaleCode) {
            $matchingOption = $modalSelect.find("option[data-locale='" + String(data.mappedLocaleCode) + "']").first();
        }

        if (!$matchingOption.length && data.geoCountry) {
            $matchingOption = $modalSelect.find("option[value='" + String(data.geoCountry) + "']").first();
        }

        if (!$matchingOption.length) {
            return;
        }

        $modalSelect.val(String($matchingOption.val() || ''));

        if (typeof $modalSelect.selectpicker === 'function') {
            $modalSelect.selectpicker('refresh');
        }

        syncModalState();
    };

    if ($modalSelect.length) {
        configureSelectpicker();
        syncModalState();

        $modalSelect.on('changed.bs.select', () => {
            syncModalState();
        });
    }

    const geoCheckUrl = $countrySelectorModal.data('geolocation-check-url');

    if (geoCheckUrl && !cookieHelpers.getCookie(GEO_DISMISSED_COOKIE)) {
        $.spinner().start();
        
        $.ajax({
            url: geoCheckUrl,
            type: 'GET',
            dataType: 'json',
            success: function (data) {
                $.spinner().stop();
                if (data) {
                    // if geo doesn't match session, show modal
                    if (data.matches === false) {
                        preselectGeoOption(data);
                        $countrySelectorModal.modal('show');
                    }
                }
            },
            error: function () {
                 $.spinner().stop();
            }
        });
    }

    $countrySelectorModal.on('hidden.bs.modal', function () {
        cookieHelpers.setCookie(GEO_DISMISSED_COOKIE, '1', {
            hours: GEO_DISMISSED_COOKIE_DAYS * 24,
            path: '/',
            sameSite: 'Lax',
            secure: window.location.protocol === 'https:'
        });
    });

    $countrySelectorModal.on('shown.bs.modal', function () {
        if ($modalSelect.length && typeof $modalSelect.selectpicker === 'function') {
            $modalSelect.selectpicker('refresh');
        }
    });

    $countrySelectorModal.on('click', function (e) {
        if (e.target === this) {
            $countrySelectorModal.modal('hide');
        }
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            $countrySelectorModal.modal('hide');
        }
    });
});